/**
 * Client-side subscribe price sync for RNC bundle PDPs.
 * Uses Shopify product JSON (allocations) when the theme section cache serves stale 10% markup.
 */
(function () {
  function roundPct(value) {
    var pct = parseFloat(value);
    return isNaN(pct) ? null : (Math.round(pct * 10) / 10).toString();
  }

  function parseProductData() {
    if (typeof productData === 'undefined') return null;
    try {
      return typeof productData === 'string' ? JSON.parse(productData) : productData;
    } catch (e) {
      return null;
    }
  }

  function excludedKeywords() {
    var raw = (document.querySelector('.rnc-page') || {}).getAttribute('data-excluded-plan-keywords') || 'lifetime';
    return String(raw)
      .toLowerCase()
      .split(',')
      .map(function (k) {
        return k.trim();
      })
      .filter(Boolean);
  }

  function planIsExcluded(planName) {
    if (!planName) return false;
    var n = String(planName).toLowerCase();
    return excludedKeywords().some(function (kw) {
      return n.indexOf(kw) >= 0;
    });
  }

  function firstVisibleAllocation(variant) {
    var list = (variant && variant.selling_plan_allocations) || [];
    for (var i = 0; i < list.length; i++) {
      var sp = list[i].selling_plan;
      if (!planIsExcluded(sp && sp.name)) return list[i];
    }
    return null;
  }

  function applySubscribePricing(productJson) {
    if (!productJson || !productJson.variants || !productJson.variants[0]) return false;
    var page = document.querySelector('.rnc-page');
    if (!page) return false;

    var variant = productJson.variants[0];
    var unitCents = variant.price;
    var alloc = firstVisibleAllocation(variant);
    if (!alloc || !alloc.price) return false;

    var subCents = alloc.price;
    var pctLabel = null;
    var groups = productJson.selling_plan_groups || [];
    outer: for (var g = 0; g < groups.length; g++) {
      var plans = groups[g].selling_plans || [];
      for (var p = 0; p < plans.length; p++) {
        if (planIsExcluded(plans[p].name)) continue;
        if (plans[p].price_adjustments && plans[p].price_adjustments[0]) {
          pctLabel = roundPct(plans[p].price_adjustments[0].value);
          break outer;
        }
      }
    }
    if (!pctLabel && unitCents > 0) {
      pctLabel = roundPct(((unitCents - subCents) / unitCents) * 100);
    }

    page.querySelectorAll('.rnc-delivery__btn[data-selling-plan]').forEach(function (btn) {
      var planId = btn.getAttribute('data-selling-plan');
      (variant.selling_plan_allocations || []).forEach(function (a) {
        if (String(a.selling_plan_id) === String(planId)) {
          btn.setAttribute('data-price', a.price);
        }
      });
      if (pctLabel) {
        var sub = btn.querySelector('.rnc-delivery__btn-sub');
        if (sub) sub.textContent = 'save ' + pctLabel + '%';
      }
    });

    var labelEl = page.querySelector('#rnc-opt-subscribe .rnc-option__name');
    if (labelEl && pctLabel) {
      labelEl.textContent = 'Subscribe & Save ' + pctLabel + '%';
    }

    var subPriceEl = page.querySelector('#rnc-subscribe-price');
    if (subPriceEl) subPriceEl.textContent = '$' + (subCents / 100).toFixed(2);

    var compareEl = page.querySelector('#rnc-subscribe-compare');
    if (compareEl) compareEl.textContent = '$' + (unitCents / 100).toFixed(2);

    if (typeof window.rnc_refreshSubscribePrices === 'function') {
      window.rnc_refreshSubscribePrices(subCents / 100, unitCents / 100);
    }

    return true;
  }

  function run() {
    var productJson = parseProductData();
    if (applySubscribePricing(productJson)) return;

    var handle =
      document.body.getAttribute('data-product-handle') ||
      document.documentElement.getAttribute('data-product-handle');
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(applySubscribePricing)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

